var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76964 0C13.8672 0 17.9995 4.02944 17.9995 9C17.9995 13.9706 13.8672 18 8.76964 18C5.16616 18 2.04542 15.9862 0.525391 13.05H2.66431C3.99341 14.9514 6.23183 16.2 8.76964 16.2C12.8477 16.2 16.1536 12.9764 16.1536 9C16.1536 5.02355 12.8477 1.8 8.76964 1.8C6.23183 1.8 3.99341 3.04864 2.66431 4.95H0.525391C2.04542 2.01379 5.16616 0 8.76964 0Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7796 3.53604C8.14004 3.18459 8.72476 3.18462 9.08522 3.53604L14.0359 8.36387C14.3964 8.71534 14.3964 9.28506 14.0359 9.63653L9.08522 14.4644C8.72476 14.8158 8.14004 14.8158 7.7796 14.4644C7.41917 14.1129 7.4192 13.5427 7.7796 13.1913L11.1552 9.9002H0V8.1002H11.1552L7.7796 4.80914C7.4192 4.45766 7.41917 3.8875 7.7796 3.53604Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.a93e06f6fa22f5c4ddf96ee43b041ecb.svg";
export { ForwardRef as ReactComponent };